import { render, staticRenderFns } from "./CustomizeUmbrella.vue?vue&type=template&id=0b5918c9&scoped=true"
import script from "./CustomizeUmbrella.vue?vue&type=script&lang=ts"
export * from "./CustomizeUmbrella.vue?vue&type=script&lang=ts"
import style0 from "./CustomizeUmbrella.vue?vue&type=style&index=0&id=0b5918c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5918c9",
  null
  
)

export default component.exports